<template>
    <span class="CheckInput">
        <input class="CheckInput__native" tabindex="-1" v-bind="{ type, checked }" />
        <span class="CheckInput__custom" />
    </span>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.CheckInput {
    .CheckInput__native {
        position: absolute;
        left: -9999px;
    }
    .CheckInput__native + .CheckInput__custom {
        position: relative;
        padding-left: 26px;
        padding-top: 7px;
        cursor: pointer;
        line-height: 20px;
        display: inline-block;
        color: #666;
    }
    .CheckInput__native + .CheckInput__custom:before {
        content: '';
        position: absolute;
        left: 7px;
        top: -9px;
        width: 18px;
        height: 18px;
        border: 1px solid #bdcfdb;
        border-radius: 100%;
        background: #f2f5f8;
    }
    .CheckInput__native + .CheckInput__custom:after {
        content: '';
        width: 12px;
        height: 12px;
        background: @brand-primary;
        position: absolute;
        top: -6px;
        left: 10px;
        border-radius: 100%;
        transition: all 0.2s ease;
    }
    .CheckInput__native:not(:checked) + .CheckInput__custom:after {
        opacity: 0;
        transform: scale(0);
    }
    .CheckInput__native:checked + .CheckInput__custom:after {
        opacity: 1;
        transform: scale(1);
    }
}
</style>

<script type="text/babel">
export default {
    components: {},

    directives: {},

    mixins: [],

    props: ['type', 'checked'],

    data() {
        return {}
    },

    computed: {},

    created() {},

    methods: {},
}
</script>
